export const notifications = {
  Direct: "Direct",
  footer: {
    from_the_last_30_days: "des 30 derniers jours.",
    That_s_all_your_notifications: "Voilà toutes vos notifications",
  },
  Last_Week: "La semaine dernière",
  Mark_all_as_read: "Marquer tout comme lu",
  Notifications: "Notifications",
  Older: "Plus ancien",
  Product: "Produit",
  Show_unread_only: "Afficher seulement les non lues",
  Today: "Aujourd'hui",
  Yesterday: "Hier",
} as const;
